/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const SurnameListPage = lazy(() => import('./pages/SurnameListPage'))
const SurnamePage = lazy(() => import('./pages/SurnamePage'))
const KoreaNLIHP = lazy(() => import('./pages/KoreaNLIHP'))
const NewBongwanPage = lazy(() => import('./pages/NewBongwanPage'))

export default [
  <SiteRoute key="home" exact path={['/', '/ko']} component={KoreaNLIHP} />,
  <SiteRoute key="surname-list" exact path="/성씨" component={SurnameListPage} />,
  <SiteRoute key="bongwan" path="/성씨/:surname/:bongwan" component={NewBongwanPage} />,
  <SiteRoute key="surname" path="/성씨/:surname" component={SurnamePage} />,
]
